module.exports = __webpack_public_path__ + "media/images/ac_templates/201/nat-e105ea00b999d9af25e73465b0bfa93f.jpg";